import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getPanNumberApi,
  getPanDetailsApi,
  getActiveUserDetailsApi,
} from "designs/v1/pages/ModifyKyc/services";
import { validateOnNumber, validateOnPaste } from "utils";
import { isEmptyObject } from "utils";

const ValidatePan = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  setActiveUserDetail,
}) => {
  const [showPanInfoModal, setShowPanInfoModal] = useState(false);
  const [panNumber, setPanNumber] = useState({
    data: [],
    loading: true,
  });
  const [panInfo, setPanInfo] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user") || {});
  const [initialValues, setInitialValues] = useState({
    emailOrPhone: user.entity?.includes("@")
      ? user.entity
      : user.entity?.slice(2),
    pan: user?.pan ?? "",
  });
  const validationSchema = Yup.object().shape({
    emailOrPhone: Yup.string()
      .required("Email or phone number is required.")
      .test("emailOrPhone", "Invalid email or phone number", function (value) {
        const phoneRegex = /^\d{10}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return phoneRegex.test(value) || emailRegex.test(value);
      }),
    pan: Yup.string()
      .min(10)
      .required("PAN number is required.")
      .matches("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$", "Invalid PAN number"),
  });

  const loadRequestTypes = async () => {
    try {
      const resp = await getPanNumberApi();
      const data = resp.data?.data?.pan_number || [];
      if (data.length === 1) {
        setInitialValues((prev) => ({ ...prev, pan: data[0] }));
      }
      setPanNumber({ data, loading: false });
    } catch (error) {
      console.error("err", error);
      setPanNumber({ data: [], loading: false });
    }
  };

  useEffect(() => {
    loadRequestTypes();
  }, []);

  const handleSubmit = async (value) => {
    setIsLoading(true);
    // const payload = {
    //   pan: value.pan,
    // };
    // try {
    //   const panResp = await getPanNumberApi(payload);
    //   const { pan_number } = panResp.data.data || [];
    //   if (!pan_number.includes(value.pan)) {
    //     setIsLoading(false);
    //     return toast.error("Error: Invalid PAN Number");
    //   }
    const userPayload = {
      pan_no: value.pan,
    };
    if (value.emailOrPhone?.includes("@")) {
      userPayload["emailOrPhone"] = value.emailOrPhone;
    } else {
      userPayload["emailOrPhone"] = `91${value.emailOrPhone}`;
    }
    try {
      const resp = await getActiveUserDetailsApi(userPayload);
      setIsLoading(false);
      if (isEmptyObject(resp.data.data || {})) {
        return toast.error(
          "User details not found or Your KYC is incomplete. Thank You!"
        );
      }
      sessionStorage.setItem(
        "user",
        JSON.stringify({
          entity: userPayload.emailOrPhone,
          type: "phone",
          pan: userPayload.pan_no,
        })
      );
      setActiveUserDetail(resp.data.data?.request_number);
      setStep("ActiveUserInfo");
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
    // try {
    //   const resp = await getPanDetailsApi(payload);
    //   setIsLoading(false);
    //   setShowPanInfoModal(true);
    //   setPanInfo(resp.data.data);
    //   sessionStorage.setItem("user", JSON.stringify({ ...user, ...payload }));
    // } catch (error) {
    //   const { data } = error.response || {};
    //   toast.error(data.message || "Internal server error!");
    //   setIsLoading(false);
    // }
    // } catch (error) {
    //   const { data } = error.response || {};
    //   toast.error(data.message || "Internal server error!");
    //   setIsLoading(false);
    // }
  };
  const handleActiveUser = async (values) => {
    setIsLoading(true);
    let payload = {
      mobile_no: `91${values.phone}`,
      pan_no: values.pan,
    };
    try {
      const resp = await getActiveUserDetailsApi(payload);
      setActiveUserDetail(resp.data.data?.request_number);
      setIsLoading(false);
      setStep("ActiveUserInfo");
    } catch (error) {
      console.log("err", error);
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Title title="Mobile Modification" />
      <div className="col-md-9 mt-3">
        <div className="ml-2">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <div className="form-group my-2">
                  <label className="py-1">Enter Phone Number or Email Address</label>
                  <Field
                    type="text"
                    name="emailOrPhone"
                    placeholder="Enter Phone Number or Email Address"
                    className="form-control"
                    // disabled={user.entity ? true : false}
                  />
                  <ErrorMessage
                    name="emailOrPhone"
                    className="inline-errormsg my-1"
                    component="div"
                  />
                </div>
                <div className="form-group my-2">
                  <label className="py-1">PAN Number</label>
                  <Field
                    as="select"
                    name="pan"
                    type="text"
                    className="form-select"
                    onChange={({ target }) =>
                      setFieldValue("pan", target.value.toUpperCase())
                    }
                  >
                    <option
                      value={""}
                      disabled
                    >
                      -- Select PAN Number --
                    </option>
                    {panNumber.data.length > 0 ? (
                      panNumber.data.map((item) => {
                        return (
                          <option
                            key={item}
                            value={item}
                          >
                            {item}
                          </option>
                        );
                      })
                    ) : (
                      <option
                        value={""}
                        disabled={panNumber.loading}
                      >
                        {panNumber.loading ? "Loading..." : "No Record Found"}
                      </option>
                    )}
                  </Field>
                  {/* <Field
                    type="text"
                    name="pan"
                    placeholder="Pan Number"
                    className="form-control"
                    onChange={({ target }) =>
                      setFieldValue("pan", target.value.toUpperCase())
                    }
                    maxLength="10"
                  /> */}
                  <ErrorMessage
                    name="pan"
                    className="inline-errormsg my-1"
                    component="div"
                  />
                </div>
                <div className="d-flex form-group my-4">
                  <div className="mx-2">
                    <Button
                      type="button"
                      title="Back"
                      handleClick={() => setStageScreen("ModificationType")}
                      loading={isLoading}
                    />
                  </div>
                  <div className="mx-2">
                    <Button
                      title="Submit"
                      disabled={isLoading}
                    />
                  </div>
                </div>
                <Modal show={showPanInfoModal}>
                  <Modal.Header>
                    <Modal.Title>Name as per PAN</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <h6>
                      Do you want to proceed with this{" "}
                      <strong>{panInfo?.full_name}</strong>
                    </h6>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      type="button"
                      title="Proceed"
                      handleClick={() => handleActiveUser(values)}
                    />
                    <Button
                      type="button"
                      title="Cancel"
                      handleClick={() => setShowPanInfoModal(false)}
                    />
                  </Modal.Footer>
                </Modal>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ValidatePan;
